import { ApolloError } from "@apollo/client";
import { useMemo } from "react";

import { ORG_ID } from "../../../../orgs.js";
import { useGetProjectLabelsForHomeQuery } from "../../queries.generated.js";

import {
  Category,
  CategoryMap,
  Status,
  StatusMap,
  toCategoryMap,
  toStatusMap,
} from "./utils.js";

export type UseCategoriesAndStatusesForOrgResult = {
  loading: boolean;
  error: ApolloError | undefined;
  categories: Category[];
  statuses: Status[];
  categoryMap: CategoryMap;
  statusMap: StatusMap;
};

export const useCategoriesAndStatusesForOrg =
  (): UseCategoriesAndStatusesForOrgResult => {
    const {
      data: labelData,
      error,
      loading,
    } = useGetProjectLabelsForHomeQuery({ variables: { orgId: ORG_ID } });

    const categories: Category[] = useMemo(
      () => (labelData?.orgById.categories ?? []).slice(),
      [labelData?.orgById.categories],
    );

    const statuses: Status[] = useMemo(
      () => (labelData?.orgById.statuses ?? []).slice(),
      [labelData?.orgById.statuses],
    );

    return useMemo(
      () => ({
        categories,
        categoryMap: toCategoryMap(categories),
        statuses,
        statusMap: toStatusMap(statuses),
        loading,
        error,
      }),
      [categories, statuses, loading, error],
    );
  };
